module.exports = __webpack_public_path__ + "static/media/jesse.b241c254.jpg";